module.exports = __webpack_public_path__ + "static/media/eu-logo.d3485fd1.png";